import { useEffect, useState } from "react";
import { isAmbiencePlaying, onAmbienceChange, toggleAmbience } from "@/lib/ambience";

const BARS = [0.5, 0.9, 0.65, 1, 0.45];

export default function AudioToggle() {
  const [on, setOn] = useState(isAmbiencePlaying());

  useEffect(() => onAmbienceChange(setOn), []);

  return (
    <button
      data-testid="audio-toggle"
      onClick={toggleAmbience}
      aria-pressed={on}
      aria-label={on ? "Mute ambient soundtrack" : "Play ambient soundtrack"}
      title={on ? "Mute ambience" : "Wind & stone ambience"}
      className={`group flex h-9 items-center gap-2 rounded-full border px-3 transition-colors duration-300 ${
        on
          ? "border-[#38BDF8]/60 text-[#38BDF8]"
          : "border-white/20 text-white/45 hover:border-[#D4AF37]/60 hover:text-[#D4AF37]"
      }`}
    >
      <span className="flex h-3.5 items-end gap-[2px]" aria-hidden>
        {BARS.map((h, i) => (
          <span
            key={i}
            className="w-[2px] origin-bottom bg-current"
            style={{
              height: "100%",
              transform: on ? undefined : `scaleY(${0.18 + h * 0.12})`,
              animation: on
                ? `aetheria-eq ${0.9 + i * 0.17}s ease-in-out ${i * 0.08}s infinite alternate`
                : "none",
              "--eq-h": h,
            }}
          />
        ))}
      </span>
      <span className="hidden font-mono text-[9px] tracking-[0.3em] lg:block">
        {on ? "AMBIENCE" : "MUTED"}
      </span>
    </button>
  );
}
